{ "imageTag": "20261103084106_2ebc82b", "buildUri": "vstfs:///Build/Build/103768", "buildId": "103768", "sourceCommit": "2ebc82bd4eda014414241efa60c1ac1d73d3e753", "sourceBranch": "main", "releaseDate": "2026-11-03T08:44:11Z" }
